import React from 'react';
import { StyledTab, StyledTabs, TabsWrapper } from '../../styles';
import { DocsTabItem } from '../../types';

interface DocsTabsProps {
  tabs: DocsTabItem[];
  currentTab: number;
  onChange: (_event: React.ChangeEvent<{}>, newValue: number) => void;
  /** When true, omit bottom margin (used on article/sub pages) */
  compact?: boolean;
}

export function DocsTabs({
  tabs,
  currentTab,
  onChange,
  compact,
}: DocsTabsProps) {
  const Wrapper = compact ? 'div' : TabsWrapper;

  return (
    <Wrapper>
      <StyledTabs
        textColor="primary"
        indicatorColor="primary"
        value={currentTab}
        onChange={onChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map(tab => (
          <StyledTab key={tab.id} label={tab.label} />
        ))}
      </StyledTabs>
    </Wrapper>
  );
}
